import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

interface IProps extends RouteComponentProps {}

/**
 * Listens to route changes and updates Google Analytics if it is installed on the page.
 * Simply place it somewhere in the Router component's tree.
 */

let GA_LISTENER_MOUNTED = false;

class GARouteListener extends React.Component<IProps> {
  cleanup: () => void;

  componentDidMount() {
    // if (GA_LISTENER_MOUNTED) {
    //   throw new Error(
    //     "There should only be one instance of the GARouteListener component mounted at a time!"
    //   );
    // }

    GA_LISTENER_MOUNTED = true;
    this.cleanup = this.props.history.listen(() => {
      // try{
        const gtag = window.gtag;
        const url = document.location ? document.location.href : null;
  
        if (typeof gtag === "function" && url) {
          const GA_TRACKING_ID = window.GA_TRACKING_ID;
  
          gtag("js", new Date());
          gtag("config", GA_TRACKING_ID, {
            page_location: url,
            page_title: document.title,
          });
        }        
      // }
      // catch(e){
      // }
    });
  }

  componentWillUnmount(): void {
    if(this.cleanup != undefined){
      GA_LISTENER_MOUNTED = false;
      this.cleanup();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(GARouteListener);



// WEBPACK FOOTER //
// ./app/javascript/components/utility/GARouteListener.tsx